<template>
  <div class="app-container-v2 process-content-container">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">缴税信息</span>
      </div>
      <div class="title-right">
        <el-button type="primary" class="button-v2" :loading="downloading" @click="handleDownload">查看缴税截图</el-button>
      </div>
    </div>

    <div class="flex vertical p24 table-body" v-loading="loading">
      <air-table
          v-if="render"
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          :show-operation="false"
          align="center"
          :columns="columns"
          :data="tableData"
          @change-filter="changeFilter"
      ></air-table>

      <vxe-pager
          class="pager-v2"
          background
          :current-page.sync="queryParams.page"
          :page-size.sync="queryParams.limit"
          :total="total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>
  </div>
</template>

<script>
import * as api from '@/api/v2/service-process/order'
import {downLoadFile} from '@/api/user/user'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      render: false,
      loading: false,
      queryParams: {
        page: 1,
        limit: 10,
      },
      total: 0,
      columns: [
        {title: '姓名', field: 'empName', minWidth: 100, filterType: 'input'},
        {title: '证件号码', field: 'identityNum', minWidth: 120, filterType: 'input'},
        {title: '报税名义', field: 'taxGroupName', minWidth: 100},
        {title: '缴税月份', field: 'taxDeclareMonth', minWidth: 100},
        {title: '缴税时间', field: 'payTime', minWidth: 120},
        {title: '应发金额', field: 'payAmount', money: true, minWidth: 100},
        {title: '税金', field: 'thisActTax', money: true, minWidth: 100},
        {title: '实发金额', field: 'actPayAmount', money: true, minWidth: 100},
      ],
      tableData: [],
      downloading: false,
    }
  },
  watch: {
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.queryParams.orderId = this.data.orderInfo.id
      this.getData()
    },
    getData() {
      this.loading = true
      api.getBizSalaryTaxByPage(this.queryParams).then(res => {
        this.tableData = res.data.data.data
        this.total = res.data.data.total
        this.loading = false
        this.render = true
      })
    },
    changeFilter(e) {
      this.queryParams = {...this.queryParams, ...e.filterData}
      this.getData()
    },
    handleDownload() {
      this.downloading = true
      api.getTaxPicture({ orderId: this.queryParams.orderId }).then(res => {
        downLoadFile(res.data.data[0].sbjtFileid).then(fileRes => {
          this.$downloadFile(fileRes)
        }).finally(() => this.downloading = false)
      }).catch(() => this.downloading = false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";

.order-info-container {
  .order-info-box:last-child {
    margin-bottom: 40px;
  }
}
.title-block {
  width: 4px;
  height: 14px;
  background: #0093AB;
  border-radius: 2px;
}
.file-list-container {
  background: #F8F9FA;
  border-radius: 4px;
  padding: 30px 20px;

  .file-box:last-child {
    margin-bottom: 0;
  }
}
</style>
